import {Module} from 'vuex';
import {AlertNotificationActions, ClubActions, ProfileActions, UrlActions} from './actions';
import {AlertNotificationGetters, ClubGetters, ProfileGetters, UrlGetters} from './getters';
import {AlertNotificationMutations, ClubMutations, ProfileMutations, UrlMutations} from './mutations';
import {AlertNotificationState, ClubState, ProfileState, UrlState} from './states';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationModule: Module<LtFramework.IAlertNotificationState, LtFramework.IRootState> = {
	namespaced: true,
	state: AlertNotificationState,
	getters: AlertNotificationGetters,
	actions: AlertNotificationActions,
	mutations: AlertNotificationMutations,
};

export const ClubModule: Module<LtFramework.IClubState, LtFramework.IRootState> = {
	namespaced: true,
	state: ClubState,
	getters: ClubGetters,
	actions: ClubActions,
	mutations: ClubMutations,
};

export const ProfileModule: Module<LtFramework.IProfileState, LtFramework.IRootState> = {
	namespaced: true,
	state: ProfileState,
	getters: ProfileGetters,
	actions: ProfileActions,
	mutations: ProfileMutations,
};

export const UrlModule: Module<LtFramework.IUrlState, LtFramework.IRootState> = {
	namespaced: true,
	state: UrlState,
	getters: UrlGetters,
	actions: UrlActions,
	mutations: UrlMutations,
};
